// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class OrganizationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
	}

	createOrganization(organization, user, callback) {
		const url = "/ecosystem/api/organizations";
		const body = JSON.stringify({ organization, user });
		this._restClient.exec_post(url, body, callback);
	}

	updateOrganization(orgId, organization, callback) {
		const url = `/ecosystem/api/organizations/${orgId}`;
		const body = JSON.stringify(organization);
		this._restClient.exec_put(url, body, callback);
	}

	deleteOrganization(orgId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}`;
		this._restClient.exec_delete(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/organizations";
		// If gets passed a callback, executes normally. Otherwise returns promise for use with async/await, etc.
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	getById(orgId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}`;
		this._restClient.exec_get(url, callback);
	}

	getOrgUsers(orgId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/users`;
		this._restClient.exec_get(url, callback);
	}

	addApplication(orgId, appId, config, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/applications/${appId}`;
		const body = JSON.stringify({
			config: config
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateApplication(orgId, appId, config, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/applications/${appId}`;
		const body = JSON.stringify({
			config: config
		});
		this._restClient.exec_put(url, body, callback);
	}

	removeApplication(orgId, appId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/applications/${appId}`;
		this._restClient.exec_delete(url, callback);
	}

	addIntegration(orgId, intId, config, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/integrations/${intId}`;
		const body = JSON.stringify({
			policy: config
		});
		this._restClient.exec_post(url, body, callback);
	}

	updateIntegration(orgId, intId, config, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/integrations/${intId}`;
		const body = JSON.stringify({
			policy: config
		});
		if (callback) {
			this._restClient.exec_put(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_put(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}

	removeIntegration(orgId, intId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/integrations/${intId}`;
		if (callback) {
			this._restClient.exec_delete(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_delete(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}

	shareIntegration(ownerOrg, orgs, intId, callback) {
		const url = `/ecosystem/api/organizations/${ownerOrg}/integrations/${intId}/share`;
		const body = JSON.stringify({
			orgs: orgs
		});
		this._restClient.exec_post(url, body, callback);
	}

	assignApps(orgId, apps, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/applications`;
		const body = JSON.stringify({
			apps: apps
		});
		this._restClient.exec_post(url, body, callback);
	}

	assignIntegrations(orgId, integrations, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/integrations`;
		const body = JSON.stringify({
			integrations: integrations
		});
		this._restClient.exec_post(url, body, callback);
	}

	setOrgProfileImage(orgId, fileHandle, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/image`;
		const body = JSON.stringify({
			fileHandle
		});

		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					} else {
						resolve(result);
					}
				});
			});
		}
	}

	getAllOrgApps(callback) {
		const url = "/ecosystem/api/orgApplications";
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get all organizations your user is able to share with
	 * @param {function} callback
	 */
	getAllOrgsForSharing(callback) {
		const url = "/ecosystem/api/organizationsForSharing";
		this._restClient.exec_get(url, callback);
	}

	bulkSaveOrganizations(data, callback) {
		const url = `/ecosystem/api/organizations/bulkSave/ecoOrganizations`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	bulkSaveIntegrations(data, callback) {
		const url = `/ecosystem/api/organizations/bulkSave/integrations`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	bulkSaveOrgProfile(data, callback) {
		const url = `/ecosystem/api/organizations/bulkSave/orgProfile`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	bulkSaveLabels(data, callback) {
		const url = `/ecosystem/api/organizations/bulkSave/labels`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Get privilege configuration for an organization
	 * Supports callback or returns a Promise when no callback is provided.
	 */
	getOrgCameraPrivileges(orgId, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/cameraPrivileges`;

		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	// Set / upsert org camera privileges
	setOrgCameraPrivileges(orgId, privileges, temporaryLockDuration, callback) {
		const url = `/ecosystem/api/organizations/${orgId}/cameraPrivileges`;
		const body = JSON.stringify({
			privileges,
			temporaryLockDuration
		});

		if (callback) {
			this._restClient.exec_post(url, body, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_post(url, body, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}
}
